import * as React from 'react'
// components
import MWMComponent from '../components/sections/MWM'

const MWM = () => {
  return (
    <div id='smooth-wrapper'>
      <div id='smooth-content'>
        <div className='podio'>
          <MWMComponent />
        </div>
      </div>
    </div>
  )
}

export default React.memo(MWM)
